const getters = {
    token: state => state.user.token,
    userId: state => state.user.userId,
    name: state => state.user.name,
    role: state => state.user.role,
    email: state => state.user.email,
    // 获取用户信息
    userInfo: state => {
        return {
            name: state.name,
            userId: state.userId,
            role: state.role,
            email: state.email,
        }
    }
  }
  export default getters
